// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBEyTmVzBJEmsKoxuHN9VTKu1eB37vKt9s",
    authDomain: "semt-aydos.firebaseapp.com",
    projectId: "semt-aydos",
    storageBucket: "semt-aydos.appspot.com",
    messagingSenderId: "541525386810",
    appId: "1:541525386810:web:36b1e525a0ba5a267bb703",
    measurementId: "G-TFG5ZPYS89"
  },
  semtID: 'aydos-country'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
